import React from "react";
import { Nav, Navbar, Container } from "react-bootstrap";

const Header = () => {
  return (
    <div>
      <Navbar bg="white" expand="lg" className="text-capitalize fw-bold mb-3">
        <Container>
          <Navbar.Brand href={`${process.env.PUBLIC_URL}/`}>
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              width=""
              height=""
              className="d-inline-block logo"
              alt={process.env.REACT_APP_APPNAME}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {false &&(<Nav className="ms-auto">
              {/* {(APP.loggedin &&
                                <Nav.Link href={`${process.env.PUBLIC_URL}/dashboard`}>Dashboard</Nav.Link>
                            )} */}
              <Nav.Link
                className="px-3"
                href={`${process.env.PUBLIC_URL}/keyfeatures`}
              >
                Key Features
              </Nav.Link>
              <Nav.Link
                className="px-3"
                href={`${process.env.PUBLIC_URL}/howto`}
              >
                How to
              </Nav.Link>
              <Nav.Link
                className="px-3"
                href={`${process.env.PUBLIC_URL}/about`}
              >
                About us
              </Nav.Link>
              <Nav.Link
                className="px-3"
                href={`${process.env.PUBLIC_URL}/offers`}
              >
                Offers
              </Nav.Link>
              {/* <Nav.Link href={`${process.env.PUBLIC_URL}/login`}>Login</Nav.Link> */}
            </Nav>)}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
